<template>
  <a-card :bordered='false'>
    <div>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-form-item :label="'日期'">
          <!--          <el-date-picker
                      v-model="paymentDate"
                      type="daterange"
                      align="right"
                      value-format="yyyy-MM-dd"
                      :clearable="false"
                    >
                    </el-date-picker>-->
          <a-range-picker
            v-model='paymentDate'
            format='YYYY-MM-DD'
            style='width: 100%;' />
        </a-form-item>
        <a-form-item>
          <a-button style='margin-left: 20px' type='primary' @click='getTableData()'>查询</a-button>
          <a-button style='margin-left: 20px' type='primary' @click="getTableData('reset')">重置</a-button>

          <a-button style='margin-left: 20px' type='primary' @click='dayFinancialComputeFun'>重新计算</a-button>
          <a-button style='margin-left: 20px' type='primary' @click='ExprotFile'>导出</a-button>
          <a-upload
            ref='upload'
            name='file'
            :multiple='false'
            :action="'/api/web/webpublic/order/importCompanyDayReportExcel'"
            :headers='getHeaders()'
            :data='uploadDataParam'
            :openFileDialogOnClick='openFileDialogOnClick'
            @change='handleChangeUpload'
          >
            <a-button
              type='primary'
              @click='openFileDialogOnClick = true'
              style='margin-left: 10px'
              :loading='uploadLoading'
            >
              上传文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>

      <a-table
        :dataSource='tableData'
        :columns='columns'
        style='width: 100%;margin-top: 20px;'
        :pagination='false'
        :loading='loading'
        :rowKey='record => record.key'
        :scroll='{x:3900 ,y: 1200}'
        bordered
      >
      </a-table>

<!--      <a-pagination-->
<!--        style='margin-top: 20px; display: flex; justify-content: flex-end;'-->
<!--        @change='handlePageChange'-->
<!--        @showSizeChange='handlePageChange'-->
<!--        v-model:current='pageConfig.pageNum'-->
<!--        :page-size='pageConfig.pageSize'-->
<!--        :page-size-options='[10, 20, 30, 60, 100]'-->
<!--        show-size-changer-->
<!--        show-quick-jumper-->
<!--        :total='pageConfig.total'-->
<!--        :show-total='total => `共 ${total} 条`'-->
<!--      />-->
    </div>
  </a-card>
</template>

<script>
import { dayFinancialList, exportCompanyDayReportExcel, dayFinancialCompute } from '@/webpublicapi/dayFinancialCompute'
import { getHeaders } from '@/utils/request'

import moment from 'moment'

export default {
  name: 'AppList',
  components: {},
  data() {
    return {
      pageConfig: {
      //   pageNum: 1,
      //   pageSize: 10,
      //   total: 100
      },
      paymentDate: [
        moment().add(-7, 'days').format('YYYY-MM-DD'),
        moment().add(-1, 'days').format('YYYY-MM-DD')
      ],

      uploadLoading: false,
      fileList: [],
      uploadDataParam: {
        // start: '2024-08-05',
        // end: '2024-08-11'
      },
      openFileDialogOnClick: false,

      tableData: [],

      loading: false,
      columns: [
        {
          title: '放款日期',
          align: 'right',
          dataIndex: 'paymentDate',
          fixed: 'left',
          width: 120
        },
        {
          title: '放款总笔数',
          dataIndex: 'paymentCountTotal',
          width: 110,
        },
        {
          title: '新户放款笔数',
          dataIndex: 'newPaymentCount',
          width: 120,
        },
        {
          title: '老户放款笔数',
          dataIndex: 'oldPaymentCount',
          width: 120,
        },
        {
          title: () => (
            <a-tooltip title="老户放款笔数 / 放款总笔数">
               <span style="cursor: pointer;">老户占比</span>
               <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'oldPaymentRate',
        },
        {
          title: '新户本金',
          dataIndex: 'newPrincipal',
          width: 110,
        },
        {
          title: () => (
            <a-tooltip title="新户合同额 / 新户放款笔数">
              <span style="cursor: pointer;">新户件均</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'newAverage',
        },
        {
          title: '新户合同金额',
          dataIndex: 'newContractAmount',
          width: 116,
        },
        {
          title: '复借款人数',
          dataIndex: 'repayCount'
        },
        {
          title: '复借率',
          dataIndex: 'repayRate',
          tip: '复借人数/ 还款总人数'
        },
        {
          title: '老户本金',
          dataIndex: 'oldPrincipal'
        },

        {
          title: () => (
            <a-tooltip title="老户合同额 / 老户放款笔数">
              <span style="cursor: pointer;">老户件均</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'oldAverage',
        },
        {
          title: '老户合同金额',
          dataIndex: 'oldContractAmount'
        },
        // {
        //   title: () => (
        //     <a-tooltip title="（新户本金+老户本金）*0.005 + 还款笔数 * 10泰铢">
        //       <span style="cursor: pointer;">支付通道成本</span>
        //       <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
        //     </a-tooltip>
        //   ),
        //   width: 142,
        //   dataIndex: 'operatingThridFee',
        // },
        {
          title: () => (
            <a-tooltip title="新户还款用户数 / 新户放款用户数">
              <span style="cursor: pointer;">新户回收率</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 128,
          dataIndex: 'newRecoveryRate',
        },
        {
          title: () => (
            <a-tooltip title="老户还款用户数 / 老户放款用户数">
              <span style="cursor: pointer;">老户回收率</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 128,
          dataIndex: 'oldRecoveryRate',
        },
        {
          title: () => (
            <a-tooltip title="实际还款金额">
              <span style="cursor: pointer;">金额回收</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'returnedAmt',
        },
        {
          title: '实际放款金额',
          dataIndex: 'payoutAmt'
        },
        {
          title: () => (
            <a-tooltip title="金额回收*0.5%（手续费费率）+ 手续费*0.035%（TAX）">
              <span style="cursor: pointer;">收款手续费用</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 142,
          dataIndex: 'newOfficeThridFee',
        },
        {
          title: () => (
            <a-tooltip title="放款笔数*（10(手续费)+0.7（TAX））">
              <span style="cursor: pointer;">放款手续费用</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 142,
          dataIndex: 'oldOfficeThridFee',
        },
        {
          title: () => (
            <a-tooltip title="源数据_美元 * 35.24泰铢">
              <span style="cursor: pointer;">流量成本</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'flowFee',
        },
        {
          title: '牌照&通道费用',
          dataIndex: 'licenceFee'
        },
        {
          title: 'ocr&活体费用',
          dataIndex: 'ocrLiveFee'
        },
        {
          title: '短信&话条费用',
          dataIndex: 'optFee'
        },
        {
          title: '催收绩效与奖金',
          dataIndex: 'performanceBonus'
        },
        {
          title: '泰国本地费用',
          dataIndex: 'thaFee'
        },
        {
          title: '总部费用',
          dataIndex: 'centerFee'
        },
        {
          title: '老挝本地费用',
          dataIndex: 'laosFee'
        },
        {
          title: '海外房租',
          dataIndex: 'rentFee'
        },
        {
          title: 'adjust费用',
          dataIndex: 'adjustFee'
        },
        {
          title: () => (
            <a-tooltip title="金额回收-实际放款金额-放款手续费用-收款手续费用-广告成本-牌照&牌照费用-ocr&活体费用-短信&话条费用-催收绩效与奖金-泰国本地费用-总部费用-老挝本地费用-海外房租-adjust费用">
              <span style="cursor: pointer;">日净现金流</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 128,
          dataIndex: 'profitAmt',
        },

        {
          title: () => (
            <a-tooltip title="昨天总现金流 + 当天日净现金流">
              <span style="cursor: pointer;">总现金流</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'cashFlow',
        },
        {
          title: () => (
            <a-tooltip title="未还款合同金额">
              <span style="cursor: pointer;">在贷余额</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 116,
          dataIndex: 'netAssets',
        },
        {
          title: () => (
            <a-tooltip title="再贷余额+总现金流">
              <span style="cursor: pointer;">净资产</span>
              <a-icon style='marginLeft:10px; cursor: pointer;' type="question-circle" />
            </a-tooltip>
          ),
          width: 106,
          dataIndex: 'netAssetsTotal',
        }
      ],
     labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    handlePageChange(page, pageSize) {
      console.log('handlePageChange triggered')
      console.log(`Page: ${page}, PageSize: ${pageSize}`)
      // if (pageSize !== undefined) {
      //   // 处理页码大小变化
      //   this.pageConfig.pageSize = pageSize
      // }
      // // 处理页码变化
      // this.pageConfig.pageNum = page

      // 重新获取数据
      this.getTableData()
    },

    dayFinancialComputeFun() {
      let time = {
        paymentDateStart: this.transformTime(this.paymentDate[0]),
        paymentDateEnd: this.transformTime(this.paymentDate[1])
      }
      dayFinancialCompute(time).then(res => {
        this.getTableData()
      })
    },
    timeSelect() {
      // let paymentDateEnd = moment(this.paymentDate).valueOf()
      // paymentDateEnd -= 3600 * 1000 * 24 * 6
      // this.paymentDateStart = moment(paymentDateEnd).format('YYYY-MM-DD')
    },
    getHeaders() {
      return getHeaders()
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getTableData(type = 'normal') {


      if (type == 'reset') {
        this.paymentDate[
          moment().add(-7, 'days').format('YYYY-MM-DD'),
            moment().add(-1, 'days').format('YYYY-MM-DD')
          ]
      }
      this.loading = true

      // let paymentDateEnd = moment(this.paymentDate).valueOf()
      // paymentDateEnd -= 3600 * 1000 * 24 * 6
      let time = {
        paymentDateStart: this.transformTime(this.paymentDate[0]),
        paymentDateEnd: this.transformTime(this.paymentDate[1])
      }
      Object.assign(this.pageConfig, time)
      dayFinancialList(this.pageConfig).then(res => {
        let data = res.data.rows
        // this.pageConfig.total = res.data.total
        this.tableData = data

        this.loading = false
      })
    },
    ExprotFile() {
      this.loading = true

      // let paymentDateEnd = moment(this.paymentDate).valueOf()
      // paymentDateEnd -= 3600 * 1000 * 24 * 6
      let time = {
        paymentDateStart: this.transformTime(this.paymentDate[0]),
        paymentDateEnd: this.transformTime(this.paymentDate[1])
      }

      exportCompanyDayReportExcel(time).then(res => {
        this.loading = false
        if (res.data != undefined) {
          this.$message.warning(res.data.message)
          return
        }
        this.downloadFile(res, `${time.paymentDateStart}_${time.paymentDateEnd}-Financial.xls`)
      })
    },

    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.getTableData()
    },
    handleCurrentChange(page) {
      this.pageConfig.pageNum = page
      // this.pageConfig.pageSize = size
      this.getTableData()
    },
    handleChangeUpload(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code === 1000) {
          this.$message.success(`${info.file.name} file uploaded successfully`)
          this.getTableData('reset')

          this.$refs.upload.sFileList = []
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        this.uploadLoading = false
        alert('system error!')
      }
    },

    downloadFile(data, name) {
      const blob = new Blob([data])
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.style.display = 'none'
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>
<style lang='less' scoped>
@import '~@/assets/less/common.less';

</style>
